export default function Logo() {
  return (
    <img
      src="/logo-wide.png"
      alt="Strovyn Painting Co."
      data-testid="navbar-brand-logo"
      className="h-8 w-auto sm:h-9"
    />
  );
}
